import React from 'react';
import PropTypes from 'prop-types';

const YoutTubeVideo = (props) => {

  return (
    <div className='youtube-video'>
      <iframe width="560" height="315" src={`https://www.youtube.com/embed/${props.id}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  );
};

YoutTubeVideo.propTypes = {
  id: PropTypes.string.isRequired
}

export default YoutTubeVideo;
